// Copyright 2016 Sorama B.V.

import { Unit, LogarithmicUnit, UnitType } from "units/Unit";

export class Frequency extends UnitType {
    public static override typeName = "Frequency";

    public static milliHertz: Unit = new Unit("mHz", 1e-3, Frequency);
    public static hertz: Unit = new Unit("Hz", 1, Frequency);
    public static kiloHertz: Unit = new Unit("kHz", 1e3, Frequency);
    public static megaHertz: Unit = new Unit("MHz", 1e6, Frequency);

    public static logHertz: Unit = new LogarithmicUnit("Hz", 10, 1, Frequency);
}
